module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f8eceee057087ff3b503b5ba964a1f4b.png";